import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useQueryParams from 'hooks/useQueryParams';
import ReactGA from 'react-ga'; //Google Analytics

import SolarisCalculator from './SolarisCalculator';

const Solaris = () => {
  const { i18n } = useTranslation(['solaris']);
  const { lang: language = 'el' } = useQueryParams();

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_ANALITICS_ID);
  }, []);

  useEffect(() => {
    const newLanguage = language ? language.toLowerCase().trim() : 'el';
    if (newLanguage.toLowerCase() === 'en') i18n.changeLanguage(newLanguage);
  }, [i18n, language]);

  const onEnergyBenefitsClick = () => {
    ReactGA.event({
      category: 'Ε.ΝA_calculator_profit',
      action: 'Click',
      label: 'Calculator_page_profit button',
    });
  };
  const onZeroBillClick = () => {
    ReactGA.event({
      action: 'Click',
      category: 'Ε.ΝA_calculator_zero bill',
      label: 'Calculator_page_zero bill button',
    });
  };

  return (
    <SolarisCalculator
      onEnergyBenefitsClick={onEnergyBenefitsClick}
      onZeroBillClick={onZeroBillClick}
    />
  );
};

export default Solaris;
